import daMessages from '../locales/da-DK';

const DaLang = {
    messages: {
        ...daMessages
    },
    locale: 'da-DK',
};

export default DaLang;